import _objectWithoutProperties from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["isOpen", "onClose", "children", "title", "closeButtonLabel", "confirmButtonLabel", "onConfirm", "variant", "size", "className", "hideClose"];
import { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { ExclamationIcon, XIcon } from '@heroicons/react/outline';
import clsx from 'clsx';
import Button from '../Button/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function Modal(_ref) {
  var isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      children = _ref.children,
      title = _ref.title,
      closeButtonLabel = _ref.closeButtonLabel,
      confirmButtonLabel = _ref.confirmButtonLabel,
      onConfirm = _ref.onConfirm,
      variant = _ref.variant,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'sm' : _ref$size,
      className = _ref.className,
      hideClose = _ref.hideClose,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(Transition, {
    appear: true,
    show: isOpen,
    as: Fragment,
    children: /*#__PURE__*/_jsxs(Dialog, {
      as: "div",
      className: "fixed inset-0 z-50 overflow-y-auto",
      onClose: onClose,
      children: [/*#__PURE__*/_jsx(Dialog.Overlay, {
        className: "fixed inset-0 bg-black opacity-50"
      }), /*#__PURE__*/_jsxs("div", {
        className: "min-h-screen text-center sm:px-4",
        children: [/*#__PURE__*/_jsx(Transition.Child, {
          as: Fragment,
          enter: "ease-out duration-300",
          enterFrom: "opacity-0",
          enterTo: "opacity-100",
          leave: "ease-in duration-200",
          leaveFrom: "opacity-100",
          leaveTo: "opacity-0",
          children: /*#__PURE__*/_jsx(Dialog.Overlay, {
            className: "fixed inset-0"
          })
        }), /*#__PURE__*/_jsx("span", {
          className: "inline-block h-screen align-middle",
          "aria-hidden": "true",
          children: "\u200B"
        }), /*#__PURE__*/_jsx(Transition.Child, {
          as: Fragment,
          enter: "ease-out duration-300",
          enterFrom: "opacity-0 scale-95",
          enterTo: "opacity-100 scale-100",
          leave: "ease-in duration-200",
          leaveFrom: "opacity-100 scale-100",
          leaveTo: "opacity-0 scale-95",
          children: /*#__PURE__*/_jsxs("div", {
            className: clsx('modal inline-block w-full transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left align-middle shadow-xl transition-all dark:border dark:border-neutral-600 dark:bg-slate-900 sm:my-8 sm:p-6', {
              'sm:max-w-sm': size === 'sm',
              'sm:max-w-md': size === 'md',
              'sm:max-w-lg': size === 'lg',
              'sm:max-w-xl': size === 'xl',
              'sm:max-w-2xl': size === '2xl',
              'sm:max-w-3xl': size === '3xl',
              'sm:max-w-4xl': size === '4xl',
              'sm:max-w-5xl': size === '5xl'
            }),
            children: [!hideClose && /*#__PURE__*/_jsxs("button", {
              type: "button",
              className: "z-50 float-right cursor-pointer rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-transparent focus:ring-offset-2",
              onClick: onClose,
              children: [/*#__PURE__*/_jsx("span", {
                className: "sr-only",
                children: "Close"
              }), /*#__PURE__*/_jsx(XIcon, {
                className: "h-8 w-8",
                "aria-hidden": "true"
              })]
            }), /*#__PURE__*/_jsx("header", {
              className: "flex items-center justify-between py-2",
              children: /*#__PURE__*/_jsxs(Dialog.Title, {
                as: "h3",
                className: "flex w-full flex-col items-center text-center text-xl font-bold leading-6 text-gray-900",
                children: [variant === 'danger' && /*#__PURE__*/_jsx(ExclamationIcon, {
                  className: "text-brand-primary mb-4 h-8 w-8"
                }), title]
              })
            }), /*#__PURE__*/_jsx("div", {
              children: children
            }), (confirmButtonLabel || closeButtonLabel) && /*#__PURE__*/_jsxs("div", {
              className: "mt-4 flex items-center justify-evenly",
              children: [confirmButtonLabel && /*#__PURE__*/_jsx(Button, {
                onClick: onClose,
                color: "secondary-outline",
                size: "lg",
                children: closeButtonLabel
              }), closeButtonLabel && /*#__PURE__*/_jsx(Button, {
                onClick: onConfirm,
                size: "lg",
                children: confirmButtonLabel
              })]
            })]
          })
        })]
      })]
    })
  });
}
export default Modal;